export default "__VITE_ASSET__qXKq9xzG__"